import SearchApi from '../../api/searchApi'

export default {
  namespaced: true,
  state: {
    results: []
  },
  mutations: {
    setResult(state, data) {
      state.results = data;
    }
  },
  actions: {
    fetch(store, searchModel) {
      return new Promise(((resolve, reject) => {
        SearchApi.fetch(searchModel).then(response => {
          store.commit('setResult', response.data);
          resolve(response.data);
        }).catch(error => {
          store.dispatch('NOTIFY_ERROR', error, { root: true});
          return reject(error);
        })
      }))
    }
  }
}
